import { useEffect, useState } from "react";
import classes from "./DeleteAccountRoute.module.css";
import { toast } from "react-toastify";
import axios from "axios";
import { otpSendApi, verifyOtpApi } from "../api/api";
import { useLocation, useNavigate } from "react-router-dom";
import Spinner from "../components/Spinner";

const OtpVerifyRoute = () => {
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading,setLoading]=useState(false);
  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (location.state?.token) {
      setToken(location?.state?.token);
      setEmail(location?.state?.email);
    } else {
      navigate("/delete-account");
    }
  }, [location]);

  const submitHandler = async (e: any) => {
    e.preventDefault();
    try {
      setDeleteLoading(true);
      const response = await axios.post(verifyOtpApi, {
        otp: otp,
        token: token,
      });
      setDeleteLoading(false);

      console.log(response, "respone....");
      toast.success("Account Deleted Successfully!");
      navigate("/terms");
    } catch (error: any) {
      setDeleteLoading(false);

      console.log(error, "error--");
      toast.error(error?.response?.data?.error);
    }
  };

  const resendOtp = async () => {
    try {
        setLoading(true);
        const response=await axios.post(otpSendApi,{
          email:email
        })
  
        setLoading(false);
  
        console.log(response,'respone....');
        setToken(response?.data?.token ?? response?.data?.result?.token);

        toast.success("Otp Resent Successfully!");
      } catch (error:any) {
        setLoading(false);
  
        console.log(error,'error--');
        toast.error(error?.response?.data?.error);
      }
  };

  return (
    <div className={classes.auth_modal}>
      <div className={classes.auth_sub_modal}>
        <div className={classes.form_modal}>
          <p className={classes.title}>OTP Verification</p>

          <form className={classes.form} onSubmit={submitHandler}>
            <input
              type="number"
              autoFocus
              placeholder="Enter Otp"
              className={classes.input}
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <button
              type="submit"
              disabled={deleteLoading}
              className={classes.signup_btn}
            >
              {deleteLoading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner />
                </div>
              ) : (
                "Verify Otp"
              )}
            </button>
          </form>

          <button
              type="button"
              disabled={loading}
              onClick={resendOtp}
              className={`${classes.signup_btn}`}
              style={{backgroundColor:"#333",color:"#fff",boxShadow:"none"}}
            >
              {loading ? (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner />
                </div>
              ) : (
                "Resend Otp"
              )}
            </button>
        </div>
        <div className={classes.benefits_modal}>
          <p className={classes.benefits_title}>
            Are You Sure You Want to Delete Your Account?
          </p>

          <div className={classes.benefits}>
            <div className={classes.benefit}>
              <div className={classes.benefit_title}>
                <i className={`pi pi-circle-fill ${classes.icon}`} />
                <p className={classes.bt}>
                  We're sorry to see you go. Deleting your account will result
                  in the following:
                </p>
              </div>
              <p className={classes.bd}>
                Permanent loss of your data and friends.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpVerifyRoute;
